import React from 'react';
import { CellProps } from 'react-table';
import { BaseRow, InputCellProps } from './helpers';
import CurrencyInput from 'react-currency-input-field';
import { Currency } from '@round/api';
import useInput from '../../../hooks/useInput';

type CurrencyInputCellProps<T extends BaseRow> = CellProps<T> &
    InputCellProps<string> & {
        currency?: Currency;
        decimalsLimit?: number;
    };

const CurrencyInputCell = <T extends BaseRow>({
    value,
    onSubmit,
    disabled,
    currency,
    decimalsLimit,
}: CurrencyInputCellProps<T>) => {
    const { onValueChange, value: inputValue, onBlur, onKeyDown } = useInput({ initialValue: value, onSubmit });

    return (
        <CurrencyInput
            disabled={disabled}
            prefix={currency?.symbol}
            groupSeparator=","
            decimalSeparator="."
            decimalsLimit={decimalsLimit}
            value={inputValue}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            onValueChange={(value) => onValueChange(value ?? '')}
        />
    );
};

export default CurrencyInputCell;
